import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import RichTextEditor from "../../RichTextEditor/RichTextEditor"
import BillingPolicyBuilderErrors from "../BillingPolicyBuilderErrors"
import BillingPolicyDepositForm from "../BillingPolicyDepositForm"
import BillingPolicyBalanceForm from "../BillingPolicyBalanceForm"
import CancellationRule from "../CancellationRule"

class BillingPolicyBuilderGeneral extends React.Component {

  constructor(props) {
    super(props);
  };

  /**
  * Render functions
  */

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <input type="hidden" name={this.inputName('id')} value={this.props.id || ''} />
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              <br />
              {
                this.props.read_only
                  ?
                  <div>{this.props.code}</div>
                  :
                  <input type="text" name={this.inputName('code')} value={this.props.code} onChange={this.props.onChange.bind(this, 'code')} className={this.renderFieldClasses('code')} data-model="BillingPolicy" data-column="code" />
              }
              {this.renderFieldErrors('code')}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              <br />
              {
                this.props.read_only
                  ?
                  <div>{this.props.name}</div>
                  :
                  <input type="text" name={this.inputName('name')} value={this.props.name} onChange={this.props.onChange.bind(this, 'name')} className={this.renderFieldClasses('name')} data-model="BillingPolicy" data-column="name" />
              }
              {this.renderFieldErrors('name')}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('terms_and_conditions')}</label>
              <br />
              {
                this.props.read_only
                  ?
                  <div dangerouslySetInnerHTML={{ __html: this.props.terms }} className="terms-and-conditions"></div>
                  :
                  <RichTextEditor height={230} name={this.inputName('terms')} body={this.props.terms} onChange={this.props.onChange.bind(this, 'terms')} className={this.renderFieldClasses('terms')} />
              }
              {this.renderFieldErrors('terms')}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="panel panel-default">
              <div className="panel-body container">
                <BillingPolicyDepositForm {...this.props} />
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="panel panel-default last">
              <div className="panel-body container">
                <BillingPolicyBalanceForm {...this.props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCancellationRules() {
    if (this.props.cancellation_rules && this.props.cancellation_rules.length > 0) {
      var cancellation_rules = this.props.cancellation_rules.map((cancellation_rule) => {
        if (cancellation_rule && !cancellation_rule.id) {
          cancellation_rule.id = this.props.generateId();
        }
        if (!cancellation_rule._destroy) {
          return <CancellationRule key={cancellation_rule.id} {...cancellation_rule} read_only={this.props.read_only} onChange={this.props.onChangeCancellationRule} onRemove={this.props.onRemoveCancellationRule} />
        }
      });
      cancellation_rules = this.cleanArray(cancellation_rules);
    }

    if (cancellation_rules && cancellation_rules.length) {
      return (
        <div className="cancellation-rules" style={{ marginBottom: -15 }}>
          {cancellation_rules}
        </div>
      );
    } else {
      return (
        <div className="jumbotron text-center" style={{ marginBottom: 0 }}>
          <span className="none">{I18n.t('none')}</span>
        </div>
      );
    }
  }

  renderErrors() {
    var errors = BillingPolicyBuilderErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  /*
  * Helper functions
  */

  cleanArray(actual) {
    var newArray = new Array();
    for (var i = 0; i < actual.length; i++) {
      if (actual[i]) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }

  inputName(name, obj) {
    var inputName = 'billing_policy';

    inputName = inputName + name;

    return inputName;
  }

  hasCancellationRuleErrors() {
    var has_errors = false;
    for (var i in this.props.errors) {
      if (i.indexOf('cancellation_rules') != -1) {
        has_errors = true;
        break
      }
    }
    return has_errors;
  }

};

export default BillingPolicyBuilderGeneral